import supportedLocales from './supportedLocales.json';

export const isSupportedLocale = (locale: string) => {
  return locale !== 'zz-zz' && supportedLocales?.includes(locale);
};

const supportedCountries = new Set();

supportedLocales.forEach((locale) => {
  if (locale?.includes('-')) {
    const [country] = locale.split('-');
    supportedCountries.add(country);
  }
});

export const isSupportedCountry = (countryCode: string) => {
  return supportedCountries.has(countryCode);
};

export function getLocaleFromPath(path: string): string | undefined {
  const segments = path.split('/').filter(Boolean);
  const potentialLocale = segments[0];
  const localePattern = /^[a-z]{2}-[a-z]{2,3}$/; // we have locale like kr-zht

  if (
    localePattern.test(potentialLocale) &&
    isSupportedLocale(potentialLocale)
  ) {
    return potentialLocale;
  }
}

export function parseLocaleFromPath(path: string): string {
  return (
    getLocaleFromPath(path) ??
    (process.env.NEXT_PUBLIC_DEFAULT_APP_LOCALE as string)
  );
}

export const isJapanLocalePathname = (pathname: string) => {
  const potentialLocale = parseLocaleFromPath(pathname);
  const localeInPathCountry = potentialLocale?.split('-')[0];
  return localeInPathCountry === 'jp';
};
